import React, { PureComponent } from 'react';

export default class EachLoanDetail extends PureComponent {
  render(){
    return(
      <div className="each-loan-detail">
        <span>{this.props.title}</span>
        <span style={this.props.styling}>{this.props.content}</span>
      </div>
    )
  }
}
